/**
 * The orchestrator's origin, shared by every caller that talks to it (chat, the
 * guardrails formatter). `/orchestrator` in local dev — a same-origin prefix
 * Vite proxies to :3002, which dodges CORS; in prod it's the orchestrator's
 * full URL. Lives here rather than in a feature so a second consumer can't
 * drift onto its own copy of the env read.
 */
export const agentBaseUrl: string =
  (import.meta.env['VITE_AGENT_API_BASE_URL'] as string | undefined) ?? '';
